<template>
  <!-- <div class="vx-card form-card template-form" ref="card">
    <div class="vx-card__header">
      <vs-col vs-type="flex" vs-align="left" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="6">
        <h3>{{"NUOVO ALLEGATO"}}</h3>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="6">
        <vs-button @click="salvaTemplate($event)" type="line" color="success" icon-pack="feather" icon="icon-save">CARICA</vs-button>
        <feather-icon icon="XIcon" @click="toggleForm = !toggleForm" class="cursor-pointer ml-2"></feather-icon>
      </vs-col>
    </div>
    <vs-divider />
    <div class="vx-card__body">
      <form v-on:submit.prevent="" data-vv-scope="template">
        <vs-row>
          <vs-col class="w-full px-2" >
            <label class="vs-input--label">{{["Carica","allegato"].join(" ")}}</label>
            <drag-drop-file v-model="value" v-validate="'required'" name="file"></drag-drop-file>
            <span class="text-danger text-sm" v-show="errors.has('template.file')">{{ errors.first('template.file') }}</span>
          </vs-col>
        </vs-row>
      </form>
    </div>
  </div> -->
  <div class="vx-card form-card template-form" ref="card">
    <div class="vx-card__header">
      <vs-col vs-type="flex" vs-align="left" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="6">
        <h3>{{"NUOVO ALLEGATO"}}</h3>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="flex-end" vs-w="6" vs-lg="6" vs-sm="6" vs-xs="6">
        <!-- <vs-button @click="salvaTemplate($event)" type="line" color="success" icon-pack="feather" icon="icon-save">CARICA</vs-button> -->
        <!-- <feather-icon icon="XIcon" @click="toggleForm = !toggleForm" class="cursor-pointer ml-2" /> -->
      </vs-col>
    </div>
    <div class="vx-card__body my-4 text-center">
      <vs-button v-if="!disabled" :disabled="upload" type="border" size="small" @click="select">
        Seleziona file
      </vs-button>
      <!-- <vs-button v-if="value" type="border" size="small" color="success" @click="getFile">
        Scarica
      </vs-button> -->
      <vs-button v-else-if="disabled" :disabled="true" type="border" size="small" color="danger">
        Nessun file
      </vs-button>
      <div class="label">
        <!-- <span class="span-label">{{label}}</span> -->
        <vs-progress v-if="upload" :percent="upload.percent" color="primary"></vs-progress>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import DragDropFile from '../../views/commons/DragDropFile.vue'
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    file: {
      required: 'Il file è un campo obbligatorio'
    },
  }
};
// register custom messages
Validator.localize('it', dict);

export default {
  components: {
    DragDropFile,
  },

  props: {
    // label: {
    //
    // },
    value: {

    },
    disabled: {

    },
  },
  data () {
    return {
      state: 'Vuoto',
      upload: null,
    }
  },

  methods: {
    // getFile() {
    //   axios.post(process.env.VUE_APP_BACKEND_API+'/rimborso/download', { nome: this.label.slice(0,15), nuovo_nome: this.value },{
    //       headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
    //       withCredentials: true,
    //       responseType: 'blob'
    //     })
    //     .then(response => {
    //     const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
    //     const link = document.createElement('a');
    //     link.href = url
    //     this.$vs.loading.close()
    //     link.setAttribute('download', response.headers['x-file-name']);
    //     document.body.appendChild(link);
    //     link.click();
    //   })
    //     .catch(e => console.log(e))
    // },

    select(ev) {
      this.pickFile(file => {
        this.upload = {
          percent: 1,
        }
        let fd = new FormData()
        fd.append('file', file)
        $http.post('rimborso/upload', fd, {
          onUploadProgress: ev => {
            this.upload.percent = 1+Math.round((ev.loaded * 100) / ev.total)
          },
        }).then(res => {
          // console.log('SUCCESS ',res);
          if (res && res.status == 201) {
            this.$emit('input', {
              nuovo_nome: res.data,
              name: file.name,
              upload_date: new Date(),
            })
          }
          // this.$emit('input', res.data, this.label)
        }).finally(res => {
          ev.stopPropagation()
          this.upload = null
        })
      })
    },

    pickFile (on_ok, on_cancel) {
      var input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.click()
      input.onchange = e => {
        var f = e.target.files[0]
        if (!f) {
          on_cancel && on_cancel()
        } else {
          on_ok && on_ok(f)
        }
      }
    },


    formData(data, name, fd) {
      fd = fd || new FormData()
      name = name || ''
      if (data && typeof data === 'object' && data.constructor.name != 'File') {
        if (Object.values(data).length == 0) {
          this.formData('', name, fd)
        } else {
          for (var index in data) {
            var value = data[index]
            if (name == '') {
              this.formData(value, index, fd)
            } else {
              this.formData(value, name + '[' + index + ']', fd)
            }
          }
        }
      } else if (data !== undefined && typeof data != 'function') {
        fd.append(name, data)
      }
      return fd
    },
  },
}
</script>

<style lang="scss" scoped>
// .vx-card {
//   -webkit-box-shadow: 10px 4px 25px 10px;
//   box-shadow: 10px 4px 25px 10px;
// }
.file-pick {
  display: flex;
  flex-direction: row;
  button {
      margin-right: 10px;
      white-space: nowrap;
  }
  .label {
    flex-grow: 1;
    .span-label {
      font-size: .9rem;
    }
  }
}
</style>
